import FlameIcon from '~/assets/icons/Flame';
import { formatNumberToK } from '~/utils/numbers';

type Props = {
  count: number;
};

const ProductNotificationCount = ({ count }: Props) => {
  return (
    <div className="flex w-full items-center justify-center gap-1 bg-purple-hola-lm px-3 py-2">
      <FlameIcon width={16} height={16} />
      <p className="text-nowrap text-xs font-normal text-purple-hola lg:hidden">
        {formatNumberToK(count)} notifications set
      </p>
      <p className="hidden text-nowrap text-xs font-normal text-purple-hola lg:block">
        {formatNumberToK(count)} notifications set in the last 7 days
      </p>
    </div>
  );
};

export default ProductNotificationCount;
